import React from "react";

// Quiet gallery loading indicator — a thin gold ring (replaces the old purple spinner).
export default function Spinner() {
	return (
		<div className="flex items-center justify-center py-12" role="status" aria-label="Loading">
			<div className="h-10 w-10 animate-spin rounded-full border border-mg-black/10 border-t-mg-gold-deep" />
		</div>
	);
}
